module.exports = __webpack_public_path__ + "static/media/hansi.32c75c64.jpg";